export function toListingUrl(queryString: string) {
  return `/cat.php?${queryString}&origin=map`;
}
